import { render, staticRenderFns } from "./docPage.vue?vue&type=template&id=fe2fe996&scoped=true&"
import script from "./docPage.vue?vue&type=script&lang=js&"
export * from "./docPage.vue?vue&type=script&lang=js&"
import style0 from "./docPage.vue?vue&type=style&index=0&id=fe2fe996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2fe996",
  null
  
)

component.options.__file = "docPage.vue"
export default component.exports